import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";

export const useGetAllRidersService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [filterState, setFilterState] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allRidersServices = useQuery({
    queryKey: [...CACHE_KEYS.RIDERS, page, debouncedQuery, filterState],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.RIDERS,
        searchParams: {
          "filter[name]": debouncedQuery,
          "filter[riderable_type]": filterState,
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allRidersServices },
    states: { searchQuery, setSearchQuery, filterState, setFilterState },
  };
};
